//modal to confirm canceling a scan in progress
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

const CancelScanModal = ({ show, handleClose, handleConfirm, loading }) => {
  return (
    <Modal show={show} onHide={loading ? undefined : handleClose} centered>
      <Modal.Header closeButton={!loading}>
        <Modal.Title>Cancel Scan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to cancel the scan in progress?
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleClose} disabled={loading}>
          No
        </Button>
        <Button variant='danger' onClick={handleConfirm} disabled={loading}>
          {loading ? (
            <>
              <Spinner animation='border' size='sm' /> Cancelling...
            </>
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelScanModal;
